module.exports = __webpack_public_path__ + "img/wyglfw3.6015d4d5.png";